// extracted by mini-css-extract-plugin
export default {"moduleThumb":"ModuleThumb_moduleThumb__o1blR","img":"ModuleThumb_img__CdcKG"};